// extracted by mini-css-extract-plugin
export default {"secondHeader":"style_secondHeader__Be-3Q","text":"style_text__jAuDR","backArrow":"style_backArrow__uHA0V"};